import React from 'react'
import _ from 'underscore'
import moment from 'moment'
import { Activity, Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import CreateComment from '../../comments/create'
import ActivityStreamItem from './ActivityStreamItem'
import { normalizeItem } from '../comms/message_card'

const CHANNEL_TOGGLES = [
  {key: 'comment', label: 'Activity'},
  {key: 'comms',   label: 'Comms'},
]

class ActivityStream extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      channels: {comment: true, comms: true},
    }
  }

  onToggleChannel = (key) => {
    this.setState((prev) => ({
      channels: {...prev.channels, [key]: !prev.channels[key]}
    }))
  }

  buildStream() {
    const { comments, comms } = this.props
    const { channels } = this.state

    const items = []

    if (channels.comment) {
      _.each(comments, (c) => {
        items.push({
          _stream_type: 'comment',
          _sort_date: c.time,
          ...c,
        })
      })
    }

    if (comms && channels.comms) {
      if (comms.mails) {
        _.each(comms.mails.items || [], (item) => {
          items.push({...normalizeItem(item, 'email'), _stream_type: 'comm'})
        })
      }
      if (comms.whatsapps) {
        _.each(comms.whatsapps.items || [], (item) => {
          items.push({...normalizeItem(item, 'whatsapp'), _stream_type: 'comm'})
        })
      }
      if (comms.smses) {
        _.each((comms.smses && comms.smses.items) || [], (item) => {
          items.push({...normalizeItem(item, 'sms'), _stream_type: 'comm'})
        })
      }
      if (comms.calls) {
        _.each((comms.calls && comms.calls.items) || [], (item) => {
          items.push({...normalizeItem(item, 'call'), _stream_type: 'comm'})
        })
      }
    }

    items.sort((a, b) => {
      const dateA = a._sort_date ? moment(a._sort_date) : moment(0)
      const dateB = b._sort_date ? moment(b._sort_date) : moment(0)
      return dateB - dateA
    })

    return items
  }

  render() {
    const { channels } = this.state
    const items = this.buildStream()

    return (
      <Card>
        <CardHeader className="flex items-center">
          <CardTitle className="flex items-center gap-2">
            <Activity className="size-4" />
            Activity
          </CardTitle>
          {this.props.comms ? (
            <CardAction className="ml-auto self-center">
              <div className="inline-flex h-8 gap-1 rounded-full bg-muted p-1">
                {_.map(CHANNEL_TOGGLES, (t) => {
                  const active = channels[t.key]
                  return (
                    <button
                      key={t.key}
                      type="button"
                      onClick={() => this.onToggleChannel(t.key)}
                      className={cn(
                        'inline-flex items-center gap-1 rounded-full px-3 text-sm font-medium transition-colors',
                        active ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
                      )}
                    >
                      <Check className={cn('size-3.5 transition-opacity', active ? 'opacity-100' : 'opacity-0')} />
                      {t.label}
                    </button>
                  )
                })}
              </div>
            </CardAction>
          ) : null}
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          {/* -mx-6/px-6 cancels CardContent's inset so the scrollbar sits at
              the card edge instead of 24px inside it. */}
          <div className="-mx-6 flex max-h-[600px] flex-col gap-2 overflow-y-auto px-6">
            <CreateComment
              commentable_type={this.props.commentable_type}
              commentable_id={this.props.commentable_id}
            />
            {items.length === 0 &&
              <div className="py-8 text-center text-sm text-muted-foreground">
                No activity yet
              </div>
            }
            {_.map(items, (item) => (
              <ActivityStreamItem
                key={item._stream_type + '-' + (item._type || 'comment') + '-' + item.id}
                item={item}
              />
            ))}
          </div>
        </CardContent>
      </Card>
    )
  }
}

export default ActivityStream
